import { render, staticRenderFns } from "./TypeOfPaymentReceiptSetting.vue?vue&type=template&id=3a0e35d6"
import script from "./TypeOfPaymentReceiptSetting.vue?vue&type=script&lang=js"
export * from "./TypeOfPaymentReceiptSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports